import {
	DismissDuplicateCandidatesMutation,
	RunDuplicateCheckMutation
} from "~/gql/mutations/duplicateCandidates.generated";
import { GetDuplicateCandidatesQuery } from "~/gql/queries/duplicateCandidates.generated";

export const duplicateCandidateEndpoints = {
	DismissDuplicateCandidates: {
		invalidatesTags: ["DuplicateCandidate"] as AddTagTypes,
		transformResponse: (res: DismissDuplicateCandidatesMutation) => res
	},
	GetDuplicateCandidates: {
		providesTags: ["DuplicateCandidate"] as AddTagTypes,
		transformResponse: (res: GetDuplicateCandidatesQuery) => res
	},
	RunDuplicateCheck: {
		invalidatesTags: ["DuplicateCandidate"] as AddTagTypes,
		transformResponse: (res: RunDuplicateCheckMutation) => res
	}
};
